import React from 'react';
import styled from 'styled-components';
import clsx from 'clsx';

import { theme } from '../layout/theme';
import { size } from '../layout/helpers';

const Wrapper = styled.div`
  &.spacing-default {
    margin: ${size(4)} 0;

    ${theme.screens.Lg} {
      margin: ${size(8)} 0;
    }
  }

  &.spacing-low {
    margin: ${size(3)} 0;

    ${theme.screens.Lg} {
      margin: ${size(6)} 0;
    }
  }

  &.drag-up {
    ${theme.screens.LtMd} {
      margin-top: -${size(4)};
    }
    ${theme.screens.Md} {
      margin-top: -${size(3)};
    }
    ${theme.screens.Lg} {
      margin-top: -${size(2)};
    }
  }

  &:has(.accent-wrapper),
  &.bg-accent {
    background-color: rgb(250, 249, 248);
  }
`;

interface IBlockSpacing {
  children: React.ReactNode;
  className?: string;
  spacing?: string;
  isAccent?: boolean;
}

const BlockSpacing = ({ children, className, spacing, isAccent }: IBlockSpacing) => (
  <Wrapper className={clsx(className, `spacing-${spacing}`, isAccent && 'bg-accent')}>
    {children}
  </Wrapper>
);

export default BlockSpacing;
